import { Component } from '@angular/core';

import { Store } from '@ngrx/store';
import * as fromRoot from './common/appstore/index';
import * as layout from './common/appstore/actions';
import { LoginService } from './services/login/login.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  date = new Date();

  constructor(
    private store: Store<fromRoot.AppState>,
    private serviceuser: LoginService
  ) {

  }

  initState() {
    this.store.dispatch(new layout.InitState());
  }

  get CurrentUser() {
    return this.serviceuser.getUser();
  }
}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/app.component.ts